import { render, staticRenderFns } from "./SelectAditivos.vue?vue&type=template&id=428d3f6b"
import script from "./SelectAditivos.vue?vue&type=script&lang=js"
export * from "./SelectAditivos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports